import { render, staticRenderFns } from "./Ordenes.vue?vue&type=template&id=69e58774&scoped=true&"
import script from "./Ordenes.vue?vue&type=script&lang=js&"
export * from "./Ordenes.vue?vue&type=script&lang=js&"
import style0 from "./Ordenes.vue?vue&type=style&index=0&id=69e58774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e58774",
  null
  
)

export default component.exports